import React from "react";
const UserBubble = ({ qrtext }) => {
  return (
    <div className="userBubbleContainer">
      <p className="userBubbleText">{qrtext}</p>
    </div>
  );
};
export default UserBubble;
